import { dayjs, QuoteIcon } from '@umanforge/common';
import { RpNoteSearch } from 'interfaces/api_deep_search.interfaces';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseCardComponent } from '../baseCard.component';

interface RpNoteCardProps {
  note: RpNoteSearch;
}

const RpNoteCardComponent: React.FC<RpNoteCardProps> = ( { note } ) => {
  const { t } = useTranslation();
  const noteRef = useRef<HTMLSpanElement>( null );

  const [ isCollapsed, setIsCollapsed ] = useState( true );
  const [ isNoteClamped, setIsNoteClamped ] = useState( false );

  useEffect( () => {
    window.addEventListener( 'resize', updatNoteClamped );

    return () => {
      window.removeEventListener( 'resize', updatNoteClamped );
    };
  }, [] );

  useEffect( () => {
    updatNoteClamped();
  }, [ noteRef ] );

  const updatNoteClamped = () => {
    let result = false;
    const currentNoteRef = noteRef.current;
    if ( currentNoteRef ) {
      result = currentNoteRef.scrollHeight > currentNoteRef.clientHeight;
    }
    setIsNoteClamped( result );
  };

  return (
    <BaseCardComponent
      id={ String( note.index ) }
      title={ note.rpTitle }
      breadcrumb={ `${ note.clientName } / ${ note.siteName }` }
      application={ note.application }
      firstChildren={
        <div className='flex flex-col h-full gap-1'>
          <div className='flex w-full h-full gap-1 items-center'>
            <QuoteIcon className="w-[40px] h-[40px] shrink-0 text-gray-300"/>
            <span
              ref={ noteRef }
              className={`w-[calc(100%_-_40px)] h-fit content-center text-[13px] text-gray-800 leading-[18px] break-words ${ isNoteClamped ? 'cursor-pointer' : '' } ${ isCollapsed ? 'line-clamp-3' : '' }`}
              onClick={ () => { if ( isNoteClamped ) { setIsCollapsed( !isCollapsed ); } } }
            >
              { note.note }
            </span>
          </div>
          <span className='text-[11px] text-gray-700 italic'> { t( 'written_on_by' ).replace( '{date}', dayjs( note.writeDate ).format( 'L' ) ).replace( '{fullname}', note.authorFullname ) } </span>
        </div>
      }
    />
  );
};

export { RpNoteCardComponent };
